import "@/App.css";
import "@/i18n";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import Navbar from "@/components/Navbar";
import HomePage from "@/pages/HomePage";
import ConfiguratorPage from "@/pages/ConfiguratorPage";
import FactoryPage from "@/pages/FactoryPage";
import AboutPage from "@/pages/AboutPage";
import ServicesPage from "@/pages/ServicesPage";
import AdminPage from "@/pages/AdminPage";
import ContactPage from "@/pages/ContactPage";
import AuthPage from "@/pages/AuthPage";
import AuthCallback from "@/pages/AuthCallback";
import MyProjectsPage from "@/pages/MyProjectsPage";
import CRMPage from "@/pages/CRMPage";
import DashboardPage from "@/pages/DashboardPage";

function App() {
  return (
    <div className="min-h-screen bg-udl-bg">
      <BrowserRouter>
        <AuthProvider>
          <Navbar />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/configurador" element={<ConfiguratorPage />} />
            <Route path="/fabrica" element={<FactoryPage />} />
            <Route path="/nosotros" element={<AboutPage />} />
            <Route path="/servicios" element={<ServicesPage />} />
            <Route path="/contacto" element={<ContactPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/auth" element={<AuthPage />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/mis-proyectos" element={<MyProjectsPage />} />
            <Route path="/crm" element={<CRMPage />} />
            <Route path="/dashboard" element={<DashboardPage />} />
          </Routes>
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
